export default {
  "3": "3",
  "4": "4",
  "5": "5",
  "personalCenterDesign": "Personal center design",
  "unsavedChanges": "Unsaved changes",
  "notPublishedDefaultTemplateIsInUse": "Not published · Default template is in use",
  "resetTemplate": "Reset template",
  "saveTemplate": "Save template",
  "publish": "Publish",
  "theMiniProgramUsesThePublishedPersonal": "The mini program uses the published personal center. This instance has not been published, so the default template may differ from the draft below. Review the menus and click Publish.",
  "avatar": "Avatar",
  "user001": "User 001",
  "member": "Member",
  "pageSettings": "Page settings",
  "pageTitle": "Page title",
  "pageLayout": "Page layout",
  "style1": "Style 1",
  "style2": "Style 2",
  "style3": "Style 3",
  "titleColor": "Title color",
  "black": "Black",
  "white": "White",
  "backgroundColor": "Background color",
  "reset": "Reset",
  "backgroundImage": "Background image",
  "selectImage": "Select image",
  "showMembership": "Show membership",
  "showNotifications": "Show notifications",
  "personalCenter": "Personal center",
  "noImageURLReturned": "No image URL returned",
  "backgroundImageUploaded": "Background image uploaded",
  "uploadFailed": "Upload failed",
  "couldNotLoadData": "Could not load data",
  "templateSaved": "Template saved",
  "couldNotSaveChanges": "Could not save changes",
  "restoreThePersonalCenterToTheDefault": "Restore the personal center to the default template? This will replace the current draft.",
  "defaultTemplateRestored": "Default template restored",
  "couldNotResetTemplate": "Could not reset template",
  "personalCenterPublished": "Personal center published",
  "couldNotPublish": "Could not publish",
  "blockSettings": "Block settings",
  "contentSettings": "Content settings",
  "showBlock": "Show block",
  "administratorEntriesAreShownAccordingToPermissions": "Administrator entries are shown according to permissions. Only icons and order can be changed; entries and destinations cannot be added or changed.",
  "recommendedImageSize100100PxDefault": "Recommended image size: 100×100 px. Default images are stored locally; uploads use OSS.",
  "dragToReorder": "Drag to reorder",
  "type": "Type",
  "content": "Content",
  "image": "Image",
  "imageURL": "Image URL",
  "upload": "Upload",
  "selectAType": "Select a type",
  "configure": "Configure",
  "addNavigation": "+ Add navigation",
  "styleSettings": "Style settings",
  "componentLayout": "Component layout",
  "layout1": "Layout 1",
  "layout2": "Layout 2",
  "itemsPerRow": "Items per row",
  "iconSize": "Icon size",
  "textSize": "Text size",
  "fontColor": "Font color",
  "iconAndTextSpacing": "Icon and text spacing",
  "itemSpacing": "Item spacing",
  "iconUploaded": "Icon uploaded",
  "bottomNavigation": "Bottom navigation",
  "showUpTo5ItemsHomeAnd": "Show up to 5 items. Home and My account are fixed and cannot be hidden or deleted.",
  "preview": "Preview",
  "add": "Add",
  "noNavigationItems": "No navigation items",
  "menuName": "Menu name",
  "linkType": "Link type",
  "inactiveIcon": "Inactive icon",
  "activeIcon": "Active icon",
  "order": "Order",
  "status": "Status",
  "visible": "Visible",
  "hidden": "Hidden",
  "actions": "Actions",
  "edit": "Edit",
  "delete": "Delete",
  "fixed": "Fixed",
  "editNavigationItem": "Edit navigation item",
  "addNavigationItem": "Add navigation item",
  "enterAMenuName": "Enter a menu name",
  "richText": "Rich text",
  "internalPage": "Internal page",
  "miniProgram": "Mini program",
  "externalLink": "External link",
  "richTextContent": "Rich text content",
  "enterRichTextContent": "Enter rich text content",
  "selectAnInternalPage": "Select an internal page",
  "theDestinationOfAFixedNavigationItem": "The destination of a fixed navigation item cannot be changed.",
  "pageParameters": "Page parameters",
  "enterPageParametersEGId1": "Enter page parameters, e.g. id=1&cat=2",
  "miniProgramAppID": "Mini program AppID",
  "enterTheDestinationMiniProgramAppID": "Enter the destination mini program AppID",
  "pagePath": "Page path",
  "enterAMiniProgramPagePathE": "Enter a mini program page path, e.g. /page/index/index",
  "enterAFullURLEGHttps": "Enter a full URL, e.g. https://www.example.com",
  "externalLinkDomainsMustBeConfiguredIn": "External link domains must be configured in the mini program console.",
  "iconURLOrEmoji": "Icon URL or emoji",
  "select": "Select",
  "recommendedImageSize8080Px": "Recommended image size: 80×80 px",
  "fixedNavigationItemsMustRemainVisible": "Fixed navigation items must remain visible.",
  "showUpTo5ItemsIncludingHome": "Show up to 5 items, including Home and My account.",
  "oK": "OK",
  "selectIcon": "Select icon",
  "useOutlineIconsForInactiveItemsAnd": "Use outline icons for inactive items and filled icons for active items.",
  "noIconsAvailableUploadAnIconFirst": "No icons available. Upload an icon first.",
  "navigationPreview": "Navigation preview",
  "noHomePageContent": "No home page content",
  "bottomNavigationPreview": "Bottom navigation preview",
  "noVisibleNavigationItems": "No visible navigation items",
  "all": "All",
  "selectALinkType": "Select a link type",
  "enterOrUploadAnInactiveIcon": "Enter or upload an inactive icon",
  "enterOrUploadAnActiveIcon": "Enter or upload an active icon",
  "pleaseSelectAStatus": "Please select a status",
  "enterAnExternalURL": "Enter an external URL",
  "enterAMiniProgramAppID": "Enter a mini program AppID",
  "home": "Home",
  "couldNotLoadPreview": "Could not load preview",
  "couldNotLoadInternalPages": "Could not load internal pages",
  "thereAreAlreadyVisibleItemsNewItems": "There are already {p0} visible items. New items will be hidden by default.",
  "couldNotUploadIcon": "Could not upload icon",
  "showUpToNavigationItemsHideAnother": "Show up to {p0} navigation items. Hide another item first.",
  "saved": "Saved",
  "added": "Added",
  "homeAndMyAccountAreFixedNavigation": "Home and My account are fixed navigation items and cannot be deleted.",
  "delete137": "Delete “{p0}”?",
  "deleteNavigationItem": "Delete navigation item",
  "deleted": "Deleted",
  "couldNotDelete": "Could not delete",
  "recordRange": "Showing {from}–{to} of {total} records",
  "draftVersion": "Saved draft v{version}",
  "expiresOn": "Expires on {date}",
  "navigationTitle": "Navigation title",
  "memberBlock": "Member services",
  "systemBlock": "System services",
  "adminBlock": "Administrator entries",
  "platformService": "Customer service",
  "myAccount": "My account",
  "supplyAndDemand": "Supply and demand"
}
